import type { LargeListFilterValue } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericLargeListFilter/GenericLargeListType';
import { LargeListFilterOperation } from '../../../../components/StatelessComponent/SingleFilter/GenericBloc/GenericLargeListFilter/GenericLargeListType';
import type { IntermediateFormat } from '../../../../domains/global-filters/model/IntermediateFormat';
import {
  QueryListOperandEnum,
  QueryMapOperandEnum,
} from '../../../../domains/global-filters/model/QueryFormat';
import type {
  QueryFormatFilter,
  QueryKeyEnum,
} from '../../../../domains/global-filters/model/QueryFormat';

export function fromUiToQueryFormat(
  uiValue: LargeListFilterValue<string> | undefined,
  queryKey: QueryKeyEnum,
): QueryFormatFilter {
  if (!uiValue) {
    return {};
  }
  const list = uiValue.selectedValues.map((item) => {
    return { [QueryMapOperandEnum.EQUAL]: { [queryKey]: item } };
  });

  const query = list.length === 1 ? list[0] : { [QueryListOperandEnum.OR]: list };
  return uiValue.operation === LargeListFilterOperation.IS_ANY_OF_THESE
    ? query
    : { [QueryMapOperandEnum.NOT]: query };
}

export function fromIntermediateToUiFormat(
  intermediateValue: IntermediateFormat,
): LargeListFilterValue<string> {
  return {
    operation:
      intermediateValue.negate === true
        ? LargeListFilterOperation.IS_NONE_OF_THESE
        : LargeListFilterOperation.IS_ANY_OF_THESE,
    selectedValues: intermediateValue.value as string[],
  };
}
